import styled from 'styled-components';
import materialUI from '../../material-UI';

export const AutoCompleteCustom = styled(materialUI.Autocomplete)``;
export const Text = styled(materialUI.TextField)`
  color: blue;
`;
